const copyUrlBtn = document.querySelector("#copyUrlBtn");
const shareInput = document.querySelector("#shareUrlInput");
const modalLaunchButtons = document.querySelectorAll(".modal-launch");
const shareModal = document.querySelector("#shareModal");
const formShareUrl = document.querySelector("#formShareUrl");
const backdrop = document.querySelector(".modal__backdrop");
const shareLinks = document.querySelector(".share-links");

const close = document.querySelector(".close");
// console.log(backdrop);

// const urlToCopy = $shareInput.val();

function copyUrl() {
    /* Select the text field */
    shareInput.select();
    shareInput.setSelectionRange(0, 99999); /* For mobile devices */
    /* Copy the text inside the text field */
    document.execCommand("copy");
    /* Log the copied text */
    // console.log("Copied the text: " + shareInput.value);
}

function showModal(modal) {
    // console.log("Clicked to launch");
    // Display block on modal
    modal.style.display = "block";
    // Add modal-open to body
    document.body.classList.add("modal-open");
    // remove fade and add show to backdrop
    backdrop.classList.add("show");
    backdrop.classList.remove("fade");


}

function hideModal(modal) {
    // console.log("Clicked to close");
    // Display block on modal
    modal.style.display = "none";
    // Add modal-open to body
    document.body.classList.remove("modal-open");
    // remove fade and add show to backdrop
    backdrop.classList.remove("show");
    backdrop.classList.add("fade");
}

if (copyUrlBtn) {
    copyUrlBtn.addEventListener("click", function () {
        copyUrl();
    });
}

modalLaunchButtons.forEach(button => {
    // console.log(button);
    button.addEventListener("click", function (e) {
        e.preventDefault(); // Stop form submitting if button is inside a form
        showModal(shareModal);
    });
});

if (close) {
    close.addEventListener("click", function () {
        hideModal(shareModal);
    });
}

// const box = document.querySelector(".modal__content");
// // Close modal on click on backdrop
// document.addEventListener("mouseup", function (e) {
//         // If event not inside modal dialog then close it - but only if modal already open
//         console.log(e.target);
//         if (e.target !== box && e.target.parentNode !== box && e.target.parentNode !== formShareUrl && e.target.parentNode !== shareLinks) {
//             hideModal(shareModal);
//         }
//     }
// );

// Close footer on click on backdrop
if (backdrop) {
    backdrop.addEventListener("click", function () {
        hideModal(shareModal);
    });
}